import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {EmpresasService} from "../superadmin/services/empresas.service";
import {BehaviorSubject} from "rxjs";
import {ArmazenamentoService} from "../services/armazenamento.service";
import {ConfiguracoesNotaFiscalService} from "./fiscal/services/configuracoes-nota-fiscal.service";



@Injectable()
export class ConstantsService {
  private moduloPedido = new BehaviorSubject<boolean>(null);
  private moduloFidelidade = new BehaviorSubject<boolean>(null);
  private moduloChatbot = new BehaviorSubject<boolean>(false);
  private moduloChatbotInstagram = new BehaviorSubject<boolean>(false);
  private moduloGarcom = new BehaviorSubject<boolean>(false);
  private moduloApp = new BehaviorSubject<boolean>(false);
  private moduloEntregadores = new BehaviorSubject<boolean>(false);
  private moduloPdv = new BehaviorSubject<boolean>(false);
  private moduloKDS = new BehaviorSubject<boolean>(false);
  private moduloFiado = new BehaviorSubject<boolean>(false);
  private moduloFiscal = new BehaviorSubject<boolean>(false);
  private emissaoNotaFiscalAtiva = new BehaviorSubject<boolean>(false);
  private impressaoAutomaticaNfce = new BehaviorSubject<boolean>(false);
  private moduloEstoque = new BehaviorSubject<boolean>(false);
  private moduloTabelaPrecos = new BehaviorSubject<boolean>(false);
  private moduloComissionamento = new BehaviorSubject<boolean>(false);
  private somenteCardapio = new BehaviorSubject<boolean>(null);
  private exibirProdutos = new BehaviorSubject<boolean>(null);
  private empresa = new BehaviorSubject<any>(null);
  private campoCpf = new BehaviorSubject<any>(null);
  private campoCnpj = new BehaviorSubject<any>(null);
  private campoDataNascimento = new BehaviorSubject<any>(null);

  moduloPedido$ = this.moduloPedido.asObservable();
  moduloFidelidade$ = this.moduloFidelidade.asObservable();
  moduloChatbot$ = this.moduloChatbot.asObservable();
  somenteCardapio$ = this.somenteCardapio.asObservable();
  exibirProdutos$ = this.exibirProdutos.asObservable();
  moduloGarcom$ = this.moduloGarcom.asObservable();
  moduloEntregadores$ = this.moduloEntregadores.asObservable();
  moduloPdv$ = this.moduloPdv.asObservable();
  possuiModuloKDS$ = this.moduloKDS.asObservable();
  moduloFiado$ = this.moduloFiado.asObservable();
  moduloFiscal$ = this.moduloFiscal.asObservable();
  emissaoNotaFiscalAtiva$ = this.emissaoNotaFiscalAtiva.asObservable();
  impressaoAutomaticaNfce$ = this.impressaoAutomaticaNfce.asObservable();
  moduloEstoque$ = this.moduloEstoque.asObservable();
  moduloTabelaPrecos$ = this.moduloTabelaPrecos.asObservable();
  moduloComissionamento$ = this.moduloComissionamento.asObservable();
  moduloApp$ = this.moduloApp.asObservable();
  moduloChatbotInstagram$  = this.moduloChatbotInstagram.asObservable();

  empresa$ = this.empresa.asObservable();
  campoCpf$ = this.campoCpf.asObservable();
  campoCnpj$ = this.campoCnpj.asObservable();
  campoDataNascimento$ = this.campoDataNascimento.asObservable();
  produtosLoja: any = [];
  insumosDaLoja: any = [];
  insumosEmAlerta: any = [];
  gruposDeInsumo: any = [];
  diasDaSemana = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];

  KEYNAOIMPRIMIR = 'nao-imprimir'
  KEYDESATIVARALERTAGARCOM = 'desativar-alerta-garcom'
  KEYPDVMOSTRARFOTOS = 'pdv-mostrar-fotos'
  naoImprimir: boolean
  naoTocarGarcom: boolean;
  pdvMostrarFotos: boolean = true;


  constructor(private httpClient: HttpClient,  private empresasService: EmpresasService,
              private armazenamentoService: ArmazenamentoService,
              private configuracoesNotaFiscalService: ConfiguracoesNotaFiscalService) {
    this.empresasService.logada().then( (empresa: any) => {
      if(!empresa || !empresa.id) {
        this.empresa.next(null);
        return;
      }

      this.carregueInformacoesDeHorarioDeFuncionamento(empresa);

      this.empresa.next ( empresa );

      this.moduloChatbot.next(this.possuiModulo(empresa, ModulosEnum.CHATBOT));
      this.moduloChatbotInstagram.next(this.possuiModulo(empresa, ModulosEnum.CHATBOT_INSTAGRAM));
      this.moduloPedido.next(this.possuiModulo(empresa, ModulosEnum.PEDIDOS));
      this.moduloKDS.next(this.possuiModulo(empresa, ModulosEnum.KDS));
      this.moduloFidelidade.next(this.possuiModulo(empresa, ModulosEnum.FIDELIDADE));
      this.somenteCardapio.next(this.possuiApenasModulo(empresa, ModulosEnum.CARDAPIO));
      this.moduloGarcom.next(this.possuiModulo(empresa, ModulosEnum.GARCOM));
      this.moduloEntregadores.next(this.possuiModulo(empresa, ModulosEnum.ENTREGADORES));
      this.moduloPdv.next(this.possuiModulo(empresa, ModulosEnum.PDV));
      this.moduloEstoque.next(this.possuiModulo(empresa, ModulosEnum.CONTROLE_ESTOQUE));
      this.moduloTabelaPrecos.next(this.possuiModulo(empresa, ModulosEnum.TABELA_PRECOS));
      this.moduloComissionamento.next(this.possuiModulo(empresa, ModulosEnum.COMISSIONAMENTO));
      this.moduloApp.next(this.possuiModulo(empresa, ModulosEnum.APP));
      this.moduloFiado.next(this.possuiModulo(empresa, ModulosEnum.FIADO));
      this.moduloFiscal.next(this.possuiModulo(empresa, ModulosEnum.FISCAL));
      this.recarregueConfiguracaoFiscal(empresa);
      this.exibirProdutos.next(this.temPedidos(empresa));
      this.campoCpf.next( this.possuiCampoExtra(empresa, 'cpf'));
      this.campoCnpj.next( this.possuiCampoExtra(empresa, 'cnpj'));
      this.campoDataNascimento.next( this.possuiCampoExtra(empresa, 'datanascimento'));
    });
    try {
      if(this.armazenamentoService.carregue(this.KEYNAOIMPRIMIR, false) === '1')
        this.naoImprimir =  true;

      if(this.armazenamentoService.carregue(this.KEYDESATIVARALERTAGARCOM, false) === '1')
        this.naoTocarGarcom = true;

      const fotosFlag = this.armazenamentoService.carregue(this.KEYPDVMOSTRARFOTOS, false);
      this.pdvMostrarFotos = fotosFlag !== '0';

    }catch(e)
    {}
  }

  temPedidos(empresa: any): boolean {
    return this.possuiModulo(empresa, ModulosEnum.CARDAPIO) || this.possuiModulo(empresa, ModulosEnum.PEDIDOS);
  }

  possuiCampoExtra(empresa: any, nomeCampo){
    if(!empresa || !empresa.camposExtras) return false;

    return empresa.camposExtras.find(campoExtra =>   campoExtra.nome === nomeCampo) != null;
  }

  possuiModulo(empresa: any, nomeModulo: string) {
    if(!empresa || !empresa.modulos) return false;

    return empresa.modulos.some(modulo =>   modulo.nome === nomeModulo);
  }

  possuiApenasModulo(empresa: any, nomeModulo: string) {
    if(!empresa || !empresa.modulos) return false;

    return empresa.modulos.length === 1 && this.possuiModulo(empresa, nomeModulo);
  }

  recarregueEmpresa(cb = null) {
    this.empresasService.logada().then((empresa: any) => {
      if(!empresa || !empresa.id) {
        this.empresa.next(null);
        if (cb) cb(null);
        return;
      }

      this.empresa.next(empresa);
      this.moduloChatbot.next(this.possuiModulo(empresa, ModulosEnum.CHATBOT));
      this.moduloPedido.next(this.possuiModulo(empresa, ModulosEnum.PEDIDOS));
      this.moduloFidelidade.next(this.possuiModulo(empresa, ModulosEnum.FIDELIDADE));
      this.somenteCardapio.next(this.possuiApenasModulo(empresa, ModulosEnum.CARDAPIO));
      this.moduloFiado.next(this.possuiModulo(empresa, ModulosEnum.FIADO));
      this.moduloFiscal.next(this.possuiModulo(empresa, ModulosEnum.FISCAL));
      this.moduloTabelaPrecos.next(this.possuiModulo(empresa, ModulosEnum.TABELA_PRECOS));
      this.moduloComissionamento.next(this.possuiModulo(empresa, ModulosEnum.COMISSIONAMENTO));
      this.recarregueConfiguracaoFiscal(empresa);
      this.exibirProdutos.next(this.temPedidos(empresa));
      this.campoCpf.next(this.possuiCampoExtra(empresa, 'cpf'));
      this.campoCnpj.next(this.possuiCampoExtra(empresa, 'cnpj'));

      if (cb) cb(empresa);

    }).catch((error) => {});
  }

  mudouEmpresa(empresa: any) {
    localStorage.setItem('alterouEmpresa', new Date().getTime().toString());
    this.empresa.next( empresa);
    this.moduloTabelaPrecos.next(this.possuiModulo(empresa, ModulosEnum.TABELA_PRECOS));
    this.moduloComissionamento.next(this.possuiModulo(empresa, ModulosEnum.COMISSIONAMENTO));
    this.recarregueConfiguracaoFiscal(empresa);
  }

  recarregueConfiguracaoFiscal(empresa: any = null) {
    const empresaAtual = empresa || this.empresa.getValue();
    if(!this.possuiModulo(empresaAtual, ModulosEnum.FISCAL)) {
      this.emissaoNotaFiscalAtiva.next(false);
      this.impressaoAutomaticaNfce.next(false);
      return;
    }

    this.configuracoesNotaFiscalService.obtenhaConfiguracoesNotaFiscal().then((configuracoes: any) => {
      this.emissaoNotaFiscalAtiva.next(!!configuracoes?.emissaoNotaAtiva);
      this.impressaoAutomaticaNfce.next(!!configuracoes?.id && configuracoes.imprimirNfceAutomaticamente !== false);
    }).catch(() => {
      this.emissaoNotaFiscalAtiva.next(false);
      this.impressaoAutomaticaNfce.next(false);
    });
  }

  private carregueInformacoesDeHorarioDeFuncionamento(empresa: any) {
    if(!empresa || !empresa.horariosHoje) return;

    if(!empresa.horariosHoje.length) {
      empresa.descricaoHorario = "Fechado";
      if(!empresa.estaRecebendoPedidos)
        empresa.mensagemAbrirPedidos = empresa.mensagemPausaProgramada || 'Não estamos recebendo pedidos hoje'

    } else {
      empresa.descricaoHorario = this.diasDaSemana[empresa.horariosHoje[0].diaDaSemana];
      let descricoesHorario = [];

      for(let i = 0; i < empresa.horariosHoje.length; i++) {
        let horarioHoje = empresa.horariosHoje[i];
        if(!horarioHoje.funciona) {
          descricoesHorario.push("Fechado");

          if(!empresa.estaRecebendoPedidos)
            empresa.mensagemAbrirPedidos = empresa.mensagemPausaProgramada || 'Não estamos recebendo pedidos hoje'

          break;
        }
        descricoesHorario.push(horarioHoje.horarioAbertura.substr(0, 5)  + " - " + horarioHoje.horarioFechamento.substr(0, 5) );
      }
      if(!empresa.mensagemAbrirPedidos && empresa.horarioAbertura)
        empresa.mensagemAbrirPedidos = 'Abre às ' + empresa.horarioAbertura;

      empresa.descricaoHorario += " " + descricoesHorario.join(" | ");
    }

    if(empresa.estaAberta) {
      empresa.formasDeEntrega.forEach( (forma: any) => {
        if(forma.tempoMinimo && forma.tempoMaximo) {
          let unidade = forma.unidadeTempo === 'HORAS' ? 'h' : (forma.unidadeTempo === 'DIAS' ? 'dias' : 'min');
          empresa.descricaoTempoEntrega =  String(`${forma.tempoMinimo} ~ ${forma.tempoMaximo} ${unidade}`);
        }
      });

      if(!empresa.estaRecebendoPedidos)
        empresa.mensagemAbrirPedidos = empresa.mensagemFechada  || 'Fechamos por alguns minutos';
    }
  }

  toogleNaoImprimir() {
    this.armazenamentoService.salveSemExpirar(this.KEYNAOIMPRIMIR, this.naoImprimir ? '1' : '0')
  }

  toogleNaoTocarGarcom() {
    this.armazenamentoService.salveSemExpirar(this.KEYDESATIVARALERTAGARCOM, this.naoTocarGarcom ? '1' : '0')
  }

  togglePdvMostrarFotos() {
    this.armazenamentoService.salveSemExpirar(this.KEYPDVMOSTRARFOTOS, this.pdvMostrarFotos ? '1' : '0')
  }
}

/**
 * Enum responsável por definir os nomes dos módulos disponíveis,
 * removendo referências diretas a strings.
 */
export enum ModulosEnum {
  CHATBOT = 'chatbot',
  CHATBOT_INSTAGRAM = 'chatbot instagram',
  PEDIDOS = 'pedidos',
  KDS = 'kds',
  FIDELIDADE = 'fidelidade',
  CARDAPIO = 'cardápio',
  GARCOM = 'garcom',
  ENTREGADORES = 'entregadores',
  PDV = 'pdv',
  CONTROLE_ESTOQUE = 'controle de estoque',
  APP = 'app',
  FIADO = 'controle fiado',
  FISCAL = 'fiscal',
  TABELA_PRECOS = 'tabela de precos',
  COMISSIONAMENTO = 'comissionamento',
}
